module.exports = __webpack_public_path__ + "static/media/ALTHAR_LOGO_VERDE_TEXTO-02-02.8f76a895.svg";